import React, {useEffect, useState} from 'react';
import _axios from "../../../../../httpService";
import {prefixUrl} from "../../../../../utils/utilsData";
import {toast} from "react-toastify";
import Loader from "../../../../Loader";
import DynaSelectBox from "../../../DynaView/DynaSelectBox";
import {ArrowIcon} from "../../ExportIcons/ExportIcons";
import DynaTextarea from "../../../DynaView/DynaTextarea";
import DynaDatePicker from "../../../DynaView/DynaDatePicker";
import DynaInput from "../../../DynaView/DynaInput";

const RecordFollowUps = ({initialData, setInitialData, setActiveTab, leadIdFromList, setReRenderLeadsList}) => {

  const [isLoad, setIsLoad] = useState(false);
  const [sendData, setSendData] = useState({
    leadId: "",
    call_result: "",
    status_result: "",
    description: "",
    alarm_date: "",
    percent: "",
  })
  const [leadInformation, setLeadInformation] = useState({
    full_name: "",
    mobile: "",
    telephone: ""
  })

  const getInitialData = async () => {
    const response = await _axios.get(prefixUrl() + "/sadenMarketingCRM/?request=followUpFormData")
    if (response?.data?.status) {
      setInitialData(response.data.data)
      setIsLoad(true)
    } else {
      toast.error(response.data.message)
    }
  }

  const getLeadInformation = async () => {
    const response = await _axios.get(prefixUrl() + "/sadenMarketingCRM/?request=leadData&leadId=" + sendData?.leadId)
    if (response?.data?.status) {
      setLeadInformation(response.data.data)
      setSendData({
        ...sendData,
        percent: response.data.data?.percent,
        call_result: initialData?.call_result_default,
        status_result: initialData?.status_result_default,
      })
    } else {
      toast.error(response.data.message)
    }
  }

  useEffect(() => {
    if (Object.keys(initialData).length === 0) {
      void getInitialData()
    } else {
      setIsLoad(true)
    }
  }, []);

  useEffect(() => {
    if (isLoad && leadIdFromList !== "") {
      setSendData({...sendData, leadId: leadIdFromList.toString()})
    }
  }, [isLoad]);

  useEffect(() => {
    if (sendData?.leadId !== "") {
      void getLeadInformation()
    }
  }, [sendData?.leadId]);

  const submitDataHandler = async () => {

    const formData = new FormData()
    formData.append("leadId", sendData?.leadId);
    formData.append("call_result", sendData?.call_result);
    formData.append("status_result", sendData?.status_result);
    formData.append("description", sendData?.description);
    formData.append("alarm_date", sendData?.alarm_date);
    formData.append("percent", sendData?.percent);

    const response = await _axios.post(prefixUrl() + "/sadenMarketingCRM/?request=followUpSubmit", formData)
    if (response?.data?.status) {
      toast.success(response.data.message)
      setSendData({
        leadId: "",
        call_result: "",
        status_result: "",
        description: "",
        alarm_date: "",
      })
      setReRenderLeadsList(Math.random() * 13)
    } else {
      toast.error(response.data.message)
    }
  }

  const addDescriptionText = (text) => {
    let temp = sendData?.description
    if (temp === "") {
      temp = text
    } else {
      temp = temp + " , " + text
    }
    setSendData({...sendData, description: temp})
  }

  try {
    return (
      <>
        {isLoad ?
          <div className={"lead-follow-ups"}>
            <div className={"box-filter"}>
              <DynaSelectBox options={initialData?.leadIdArray}
                             hasFilter={true}
                             label={"کد لید"}
                             className={"solid-dyna-input"}
                             value={sendData?.leadId}
                             onChange={(data) => setSendData({
                               ...sendData,
                               leadId: data.value,
                             })}
              />
              {sendData?.leadId !== "" &&
                <>
                  <div className={"inline-text-row"}>
                    <h6>نام و نام خانوادگی : </h6>
                    <h6>{leadInformation?.full_name}</h6>
                  </div>
                  <div className={"inline-text-row"}>
                    <h6>شماره موبایل : </h6>
                    <h6>{leadInformation?.mobile}</h6>
                  </div>
                  <div className={"inline-text-row"}>
                    <h6>تلفن ثابت : </h6>
                    <h6>{leadInformation?.telephone}</h6>
                  </div>
                </>}
            </div>
            {sendData?.leadId !== "" &&
              <div className={"parent-follow-box"}>
                <div className={"inline-text-row"}>
                  <ArrowIcon/>
                  <h5>تعداد تخصیص لید</h5>
                </div>
                <div className={"follow-box"}>
                  <div className="radio-button-group">
                    <h5>نتیجه تماس</h5>
                    <div className={"parent-row"}>
                      {initialData?.call_result_array.map((item, index) => (
                        <label key={index + "ownerShipType"} className="radio-label" style={{color: item?.colorCode}}>
                          <input
                            type="radio"
                            name="call_result"
                            value={item.value}
                            checked={sendData?.call_result === item.value}
                            onChange={() => setSendData({...sendData, call_result: item?.value})}
                            className="radio-input"
                          />
                          <span className="custom-radio"></span>
                          {item.label}
                        </label>
                      ))}
                    </div>
                  </div>
                  <div className="radio-button-group">
                    <h5>نتیجه وضعیت</h5>
                    <div className={"parent-row"}>
                      {initialData?.status_result_array.map((item, index) => (
                        <label key={index + "ownerShipType"} className="radio-label" style={{color: item?.colorCode}}>
                          <input
                            type="radio"
                            name="status_result_array"
                            value={item.value}
                            checked={sendData?.status_result === item.value}
                            onChange={() => setSendData({...sendData, status_result: item?.value})}
                            className="radio-input"
                          />
                          <span className="custom-radio"></span>
                          {item.label}
                        </label>
                      ))}
                    </div>
                  </div>
                  <div className="radio-button-group">
                    <h5> نتیجه پیگیری</h5>
                    <div className={"parent-row"} style={{gridTemplateColumns: 'repeat(5, 1fr)'}}>
                      <DynaDatePicker label={"تاریخ هشدار"}
                                      name={"alarm_date"}
                                      className={"solid-dyna-input"}
                                      value={sendData?.alarm_date}
                                      setDataFromComponent={(data) => {
                                        setSendData({...sendData, ...data})
                                      }}
                      />
                      <DynaInput label={"درصد تمایل مشتری"}
                                 name={"percent"}
                                 className={"solid-dyna-input"}
                                 placeholder={"درصد تمایل مشتری را وارد کنید"}
                                 value={sendData?.percent}
                                 type={"number"}
                                 setDataFromComponent={(data) => {
                                   if (!isNaN(data?.percent) && +data?.percent < 101) {
                                     setSendData({...sendData, ...data})
                                   }
                                 }}
                      />
                      <div style={{gridColumn: "1/-1"}}></div>
                      {initialData?.textSuggestion.map((item, index) => (
                        <button key={"but" + index} className={"button-add-text"}
                                onClick={() => addDescriptionText(item)}>
                          {item}
                        </button>
                      ))}
                      <div style={{gridColumn: "1/-1"}}>
                        <DynaTextarea label={"توضیحات"}
                                      name={"description"}
                                      style={{height: '140px'}}
                                      className={"solid-dyna-input"}
                                      placeholder={"توضیحات را وارد کنید"}
                                      value={sendData?.description}
                                      type={"text"}
                                      setDataFromComponent={(data) => {
                                        setSendData({...sendData, ...data})
                                      }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            {sendData?.leadId !== "" &&
              <div className={"button-side"}>
                <button onClick={submitDataHandler}>ثبت</button>
                <button className={"cansel-button"} onClick={() => setActiveTab(1)}>انصراف</button>
              </div>
            }
          </div> : <Loader/>
        }
      </>
    );
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }
};

export default RecordFollowUps;